import { createContext, useContext, useRef, useState, useCallback } from "react";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription, DialogFooter } from "@/components/ui/dialog";

const Ctx = createContext(null);

/** Confirmation impérative globale (promesse) — « toujours confirmer avant de supprimer ». */
export function ConfirmProvider({ children }) {
  const [state, setState] = useState(null);
  const resolver = useRef(null);
  const confirm = useCallback((opts = {}) => new Promise((resolve) => {
    resolver.current = resolve;
    setState({ title: "Confirmer la suppression", message: "Cette action est irréversible.", confirmLabel: "Supprimer", danger: true, ...opts });
  }), []);
  const done = (v) => { resolver.current?.(v); resolver.current = null; setState(null); };
  return (
    <Ctx.Provider value={confirm}>
      {children}
      <Dialog open={!!state} onOpenChange={(o) => !o && done(false)}>
        <DialogContent className="max-w-sm">
          <DialogHeader>
            <DialogTitle>{state?.title}</DialogTitle>
            <DialogDescription>{state?.message}</DialogDescription>
          </DialogHeader>
          <DialogFooter>
            <button data-testid="confirm-cancel" onClick={() => done(false)} className="px-4 py-2 rounded-lg border border-slate-200 text-sm">Annuler</button>
            <button data-testid="confirm-ok" onClick={() => done(true)} className={`px-4 py-2 rounded-lg text-white text-sm font-medium ${state?.danger ? "bg-red-600" : "bg-emerald-600"}`}>{state?.confirmLabel}</button>
          </DialogFooter>
        </DialogContent>
      </Dialog>
    </Ctx.Provider>
  );
}

export const useConfirm = () => useContext(Ctx);
